/**
 * Skip to Content Accessibility
 *
 * Ensures that activating the Skip to Content link moves keyboard
 * focus directly to the main page content.
 */

(function () {
  function initSkipToContent() {
    const skipLink = document.querySelector(".as-skip-to-content-link");
    const mainContent = document.getElementById("MainContent");

    if (!skipLink || !mainContent) return;

    skipLink.addEventListener("click", function () {
      mainContent.focus({
        preventScroll: true,
      });
    });
  }

  window.ASA11y.onReady(initSkipToContent);
})();
